import React from 'react';
import './Process.css';

const STEPS = [
  { num: '01', title: 'Discover', desc: 'A scoping call to map goals, constraints, and the fastest path to value.' },
  { num: '02', title: 'Plan', desc: 'A clear roadmap with milestones, owners, and honest timelines.' },
  { num: '03', title: 'Build', desc: 'Senior teams ship in weekly increments you can see and test.' },
  { num: '04', title: 'Grow', desc: 'Launch, measure, and iterate, with marketing and product moving together.' },
];

export default function Process() {
  return (
    <section className="process" id="process">
      <div className="process-heading">
        <h2 data-reveal>How we work</h2>
        <div className="process-eyebrow" data-reveal>PROCESS</div>
      </div>
      <div className="process-grid">
        <div className="process-connector" aria-hidden="true" />
        {STEPS.map((st) => (
          <div className="process-step" data-reveal key={st.num}>
            <div className="process-num">{st.num}</div>
            <div className="process-title">{st.title}</div>
            <div className="process-desc">{st.desc}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
